import { IApplicationState } from '../../types/redux';

export const selectEstimationChartState = (state: IApplicationState) => state.estimationChart;

export const selectEstimationChartData = (state: IApplicationState) => state.estimationChart.data;
